import * as actionTypes from '../action-types';

export const updateHeaderPanes = (list = []) => {
  return {
    type: actionTypes.HEADER_PANES,
    list: list,
    MsgFlag: false
  }
}

export const updateHeaderPaneKey = (key) => {
  return {
    type: actionTypes.HEADER_CUR_PANE,
    key
  }
}

export const updateMsgOnekey = (flag) => {
  return {
    type: actionTypes.Msg_One_Key,
    flag
  }
}
